export enum TimeFilterEnum {
    ThisWeekDescription = 'This Week',
    ThisWeek = 1,
    Last30DaysDescription = 'Last 30 Days',
    Last30Days = 2,
    Last60DaysDescription = 'Last 60 Days',
    Last60Days = 3,
    CustomDescription = 'Custom',
    Custom = 4,
}
